
import { computed, defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    components: {
        Cheap,
    },
    props: {
        status: {
            type: Object as PropType<{ id: number; name: string }>,
            required: true,
        },
    },
    setup(props) {
        const cheapClasses = computed(() => {
            return {
                yellow: props.status.id === 1,
                green: props.status.id === 2,
            }
        })

        return {
            cheapClasses,
        }
    },
})
